import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { List, ListEntryTypes, ListPropertySubscription } from '@site-mate/dashpivot-shared-library';

import { AppHierarchy } from 'app/shared/model/app-hierarchy.enum';
import { HttpClientService } from 'app/shared/service/http-client.service';

export interface UpdateListCellParams {
  listId: string;
  rowId: string;
  propertyId: string;
  value: any;
  parentId: string;
  hierarchy: AppHierarchy;
}

@Injectable({ providedIn: 'root' })
export class ListPropertyService {
  constructor(private readonly httpClientService: HttpClientService) {}

  private getFolderLevel(hierarchy: AppHierarchy): string {
    const folderMapping = { [AppHierarchy.Organisation]: 'companies', [AppHierarchy.Project]: 'projects' };
    return folderMapping[hierarchy];
  }

  create(
    listId: string,
    params: { kind: ListEntryTypes; index: number; name: string },
    parentId: string,
    hierarchy: Exclude<AppHierarchy, AppHierarchy.Team>,
  ): Observable<List> {
    const URL = `${this.getFolderLevel(hierarchy)}/${parentId}/lists/${listId}/property`;
    return this.httpClientService.post(URL, params);
  }

  update(
    listId: string,
    propertyId: string,
    params: { index?: number; name?: string; susbcribedUsers?: ListPropertySubscription },
    parentId: string,
    hierarchy: AppHierarchy,
  ): Observable<List> {
    const URL = `${this.getFolderLevel(hierarchy)}/${parentId}/lists/${listId}/property/${propertyId}`;
    return this.httpClientService.put(URL, params);
  }

  delete(
    listId: string,
    propertyId: string,
    parentId: string,
    hierarchy: Exclude<AppHierarchy, AppHierarchy.Team>,
  ): Observable<List> {
    const URL = `${this.getFolderLevel(hierarchy)}/${parentId}/lists/${listId}/property/${propertyId}`;
    return this.httpClientService.remove(URL);
  }

  updateCell({
    listId,
    rowId,
    propertyId,
    value,
    parentId,
    hierarchy,
  }: UpdateListCellParams): Observable<List> {
    const URL = `${this.getFolderLevel(
      hierarchy,
    )}/${parentId}/lists/${listId}/row/${rowId}/property/${propertyId}`;
    return this.httpClientService.put<List>(URL, { value });
  }

  getAddAttachmentToCellUrl(
    uploadUrlBase: string,
    listId: string,
    rowId: string,
    propertyId: string,
  ): string {
    return `${uploadUrlBase}/lists/${listId}/row/${rowId}/property/${propertyId}/attachments`;
  }
}
